// extracted by mini-css-extract-plugin
export default {"SocialIcons":"SocialIcons_SocialIcons__QAVVz","Facebook":"SocialIcons_Facebook__GfBpf","Instagram":"SocialIcons_Instagram__kNAFS"};